import { createSlice } from '@reduxjs/toolkit';
import { fetchPaymentInfo } from './paymentThunks';

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    data: null,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentInfo.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPaymentInfo.fulfilled, (state, action) => {
        state.status = 'succeeded'; 
        state.data = action.payload;
      })
      .addCase(fetchPaymentInfo.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default paymentSlice.reducer;